import * as PropTypes from 'prop-types';
import Button from 'antd/lib/button';
import Alert from 'antd/lib/alert';
import { TextField, TextAreaField, DatePickerField } from '@ackee/mateus';

import { useFela } from 'react-fela';
import { useIntl, FormattedMessage } from 'react-intl';
import Tabs from 'antd/lib/tabs';

import moment from 'moment';

import config from 'config/index';
import { Uploader, fileShape } from 'modules/uploader';
import { SelectField } from 'modules/ui';

import rule from './NewsForm.rule';

const TabPane = Tabs.TabPane;
const NewsForm = ({ delayed, handleSubmit, submitting, error, initialValues }) => {
    const { css } = useFela();
    const intl = useIntl();

    return (
        <form onSubmit={handleSubmit} className={css(rule)}>
            <h3>
                <FormattedMessage id="form.section.translations" />
            </h3>
            {error && <Alert type="error" message={intl.formatMessage({ id: error })} />}
            <Tabs>
                {config.app.languages.map(lang => (
                    <TabPane tab={<FormattedMessage id={`languages.${lang}`} />} key={lang}>
                        <TextField
                            name={`${lang}.title`}
                            label={intl.formatMessage({ id: `news.add.form.title.label` })}
                            labelAlign="left"
                            labelCol={{ span: 24 }}
                        />
                        <TextAreaField
                            name={`${lang}.body`}
                            label={intl.formatMessage({ id: `news.add.form.body.label` })}
                            rows="10"
                            labelAlign="left"
                            labelCol={{ span: 24 }}
                        />
                    </TabPane>
                ))}
            </Tabs>
            <h3>
                <FormattedMessage id="form.section.optional" />
            </h3>
            <SelectField
                name="tags"
                mode="tags"
                tokenSeparators={[',']}
                dropdownClassName="tags-dropdown"
                label={intl.formatMessage({ id: `news.add.form.tags.label` })}
                labelAlign="left"
                labelCol={{ span: 24 }}
            />
            {delayed ? (
                <DatePickerField
                    name="time"
                    showTime
                    displayFormat="DD.MM.YYYY HH:mm"
                    disabledDate={current => current && current < moment().subtract(1, 'day').endOf('day')}
                    label={intl.formatMessage({ id: `news.add.form.time.label` })}
                    labelAlign="left"
                    labelCol={{ span: 24 }}
                />
            ) : null}
            <Uploader name="images" initialFiles={initialValues.images} />
            <Button type="primary" htmlType="submit" loading={submitting}>
                <FormattedMessage id="news.add.form.submit" />
            </Button>
        </form>
    );
};

NewsForm.propTypes = {
    delayed: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    initialValues: PropTypes.shape({
        images: PropTypes.arrayOf(fileShape),
    }).isRequired,
    error: PropTypes.string,
};

NewsForm.defaultProps = {
    delayed: false,
    error: null,
};

export default NewsForm;
